/* Puzzle Post landing-page kit (pp-*): locks, reveals, videos, add-to-cart, anchor scrolling. Loaded by every pp- section. */
(function () {
  if (window.__ppLanding) { if (window.__ppLanding.init) window.__ppLanding.init(document); return; }
  var doc = document, de = doc.documentElement;
  de.classList.add('pp-js');
  var design = !!(window.Shopify && window.Shopify.designMode);

  function all(sel, root) { return [].slice.call((root || doc).querySelectorAll(sel)); }

  /* ---------- fade-up reveals ---------- */
  var io = null;
  if ('IntersectionObserver' in window && !design) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
  }
  function initReveals(root) {
    all('.pp-reveal:not(.is-in)', root).forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });
  }

  /* ---------- tap-a-lock ---------- */
  function setLock(tile, scroll) {
    var group = tile.closest('[data-pp-locks]'); if (!group) return;
    all('[data-pp-tile]', group).forEach(function (b) {
      var on = b === tile, p = doc.getElementById(b.getAttribute('aria-controls'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (p) p.classList.toggle('is-on', on);
    });
    var hint = group.querySelector('[data-pp-hint]'); if (hint) hint.style.display = 'none';
    if (scroll && window.matchMedia('(max-width:820px)').matches) {
      var stage = group.querySelector('[data-pp-stage]'); if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  function initLocks(root) {
    all('[data-pp-locks]', root).forEach(function (group) {
      if (group.__ppDone) return; group.__ppDone = true;
      var touched = false, tiles = all('[data-pp-tile]', group);
      tiles.forEach(function (t) { t.addEventListener('click', function () { touched = true; setLock(t, true); }); });
      var row = group.querySelector('[data-pp-tiles]');
      if (row && tiles.length && !design && 'IntersectionObserver' in window) {   /* first lock opens itself once as a demo */
        var demo = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (!e.isIntersecting) return; demo.disconnect(); setTimeout(function () { if (!touched) setLock(tiles[0], false); }, 700); });
        }, { threshold: 0.6 });
        demo.observe(row);
      }
    });
  }

  /* ---------- videos: click poster to play ---------- */
  function initVideos(root) {
    all('[data-pp-video]', root).forEach(function (v) {
      if (v.__ppDone) return; v.__ppDone = true;
      v.addEventListener('click', function () {
        var src = v.getAttribute('data-src'); if (!src) return;
        var el = doc.createElement('video'); el.src = src; el.controls = true; el.autoplay = true; el.playsInline = true; el.setAttribute('playsinline', '');
        v.innerHTML = ''; v.appendChild(el);
      }, { once: true });
    });
  }

  /* ---------- add to cart (same pattern as the other landing pages) ---------- */
  function openCart() { try { if (window.Alpine && Alpine.store('modals')) Alpine.store('modals').open('cart'); } catch (e) {} }
  doc.addEventListener('click', function (e) {
    var st = e.target.closest ? e.target.closest('[data-pp-step]') : null;     /* quantity - / + */
    if (st) {
      var inp = st.parentNode.querySelector('input');
      if (inp) inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + Number(st.getAttribute('data-pp-step')));
      return;
    }
    var a = e.target.closest ? e.target.closest('.pp-pl a[href^="#"]') : null;
    if (a && a.getAttribute('href').length > 1) {
      var id = a.getAttribute('href').slice(1), t = doc.getElementById(id);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    var b = e.target.closest ? e.target.closest('[data-pp-add]') : null; if (!b) return;
    var vid = b.getAttribute('data-pp-add'); if (!vid || b.disabled) return;
    var label = b.textContent; b.disabled = true;
    var qf = b.closest('form'), qi = qf ? qf.querySelector('input[name="quantity"]') : null;
    var qty = Math.max(1, parseInt(qi && qi.value, 10) || 1);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        var done = false, go = function () { if (done) return; done = true; doc.removeEventListener('theme:cart:update', go); openCart(); };
        doc.addEventListener('theme:cart:update', go);
        doc.dispatchEvent(new CustomEvent('theme:update:cart'));
        setTimeout(go, 1200);
      })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { b.disabled = false; b.textContent = label; });
  });

  function init(root) { initReveals(root); initLocks(root); initVideos(root); }
  window.__ppLanding = { init: init };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); }); else init(doc);

  /* ---------- theme editor ---------- */
  if (design) {
    doc.addEventListener('shopify:section:load', function (e) { all('.pp-reveal', e.target).forEach(function (el) { el.classList.add('is-in'); }); init(e.target); });
    doc.addEventListener('shopify:block:select', function (e) {
      var t = e.target.querySelector ? e.target.querySelector('[data-pp-tile]') : null; if (t) setLock(t, false);
    });
  }
})();